  $(document).ready(function () {
    var $fixedSubmenu = $('.fixed-submenu-wrapper');
    var $conversionCtas = $('#conversion-ctas');
    var $arrowDown = $('.arrow__down');
    var $vb_tooltip_box = $('.vb_tooltip_box');
    var hideTimeout;
    var isSubmenuOpen = false; // Track if a submenu is open

function setSubmenuMaxHeight() {
  var availableHeight = $(window).height() - 20; 
    $fixedSubmenu.css('max-height', availableHeight + 'px');
} 
setSubmenuMaxHeight();
$(window).resize(setSubmenuMaxHeight);

    // Show submenu
    function showSubmenu($submenuContent) {
        if (!$submenuContent || !$submenuContent.length) {
          return;
        }
        clearTimeout(hideTimeout);
        var $submenuClone = $submenuContent.clone().show();
        $fixedSubmenu.html($submenuClone).stop(true, true).slideDown(200);
        setSubmenuMaxHeight();
        isSubmenuOpen = true; 
        $(".hover-overlay").stop(true, true).fadeIn(200); 
    }
   // Hide submenu
    function hideSubmenu() {
        hideTimeout = setTimeout(function () {
            if (!$fixedSubmenu.is(':hover') && !$vb_tooltip_box.is(':hover')) {
                if ($fixedSubmenu.is(':visible')) {
                    $fixedSubmenu.slideUp(200);
                    $conversionCtas.slideUp(200);
                    $arrowDown.addClass('arrow__down').removeClass('arrow__up');
                    $(".hover-overlay").stop(true, true).fadeOut(200); // Hide overlay
                    isSubmenuOpen = false; // Mark submenu as closed
                }
            }
        }, 200);
    }
    // Hover events for showing and hiding submenu
    $('.has-submenu').hover(
        function () {
            var submenuId = $(this).find('.VBsubmenu').attr('id');
            if (!submenuId) return;
            var $submenuContent = $('#' + submenuId);
            showSubmenu($submenuContent);
        },
        function () {
            hideSubmenu();
        }
    );
    // Keep submenu open if hovering over it directly
    $fixedSubmenu.hover(
        function () {
            clearTimeout(hideTimeout);
        },
        function () {
            hideSubmenu();
        }
    );
    // conversion rate buttons section
    $(document).on('pointerdown', '.arrow__down, .arrow__up', function (e) {
      e.preventDefault();
      e.stopPropagation();
      
      const isArrowDown = $(this).hasClass('arrow__down');
      $(this).toggleClass('arrow__down arrow__up');
      
      if (isArrowDown) {
          $conversionCtas.slideDown(200).addClass('hide__conversion_ctas');
      } else {
          $conversionCtas.slideUp(200).removeClass('hide__conversion_ctas');
      }
  });

    // Initialize hover-overlay
    $("body").append('<div class="hover-overlay"></div>');
    $(".hover-overlay").hide();
});
